import React, { useState, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Noti from "../../../util/noti";
import { useUser } from "../../../util/user";

import "./style.css";
import SiteCreationNav from "./SiteCreationNav";
import { useRouteWithData } from "../../../util/router";

function SiteCreationChild(props) {
	const user = useUser();
	const siteView = user.roles.includes("administration:SiteCreation:_view");
	const siteLicense = user.roles.includes("administration:SiteCreation:_license");
	const siteAdmin = user.roles.includes("administration:SiteCreation:_admin");
	const siteCons = user.roles.includes("administration:SiteCreation:_editCons");
	const consApproval = user.roles.includes("administration:SiteCreation:_approvalCons");
	const permissions = { siteView, siteLicense, siteAdmin, siteCons, consApproval };

  const requiredRoles = props.requiredRoles;

	const { openLink } = useRouteWithData();

	const hideNavBar = props.hideNavBar;
	const showCreateNewSiteBtn = props.showCreateNewSiteBtn;

	if(!requiredRoles.every(role => user.roles.includes(role))) {
		return <p><b>Access Denied</b>: You don't have permission to view this content</p>;
	}

	return (
		<Container fluid id="siteCreation">
			<div>
				<h3 id="sc-h3">SITE CREATION</h3>

				{siteCons && showCreateNewSiteBtn && (
					<div>
						<button
							className="btn btn-primary"
							onClick={e => openLink(e, "/solar/administration/site-creation/manage-site/construction-form", {})}
							style={{ marginBottom: "10px" }}
						>
							NEW SITE <i className="glyphicon glyphicon-plus"></i>
						</button>
					</div>
				)}

				{!hideNavBar && <SiteCreationNav permissions={permissions} />}

				<div>
					{props.children}
				</div>

			</div>

			<Noti />
		</Container>
	);
}

export default SiteCreationChild;
